<app-reactive-select-input
  *ngIf="abstractControls.area$ | async as areaObserv"
  [fieldId]="'inputGroupArea'"
  [filedLabel]="areaObserv?.title"
  [isInline]="isInline"
  [control]="control"
  [keyOptions]="keyValueOptions"
>
</app-reactive-select-input>
